import { ToggleCard } from '../ToggleCard';
export function CheckCard(props) {
    return <ToggleCard type="checkbox" {...props}/>;
}
